import ingredients from 'data/ingredients';
import effectMap from 'data/effectMap';

export default ingredients.map(ingredient => ({
  ...ingredient,
  effects: ingredient.effects.map(name => effectMap[name]),
}));
